var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanBarcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 8.24967V5.95801C1.83325 3.67551 3.67575 1.83301 5.95825 1.83301H8.24992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.83301H16.0417C18.3242 1.83301 20.1667 3.67551 20.1667 5.95801V8.24967",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 14.667V16.042C20.1667 18.3245 18.3242 20.167 16.0417 20.167H14.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24992 20.1667H5.95825C3.67575 20.1667 1.83325 18.3242 1.83325 16.0417V13.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62508 6.41699V8.25033C9.62508 9.16699 9.16675 9.62533 8.25008 9.62533H6.41675C5.50008 9.62533 5.04175 9.16699 5.04175 8.25033V6.41699C5.04175 5.50033 5.50008 5.04199 6.41675 5.04199H8.25008C9.16675 5.04199 9.62508 5.50033 9.62508 6.41699Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 6.41699V8.25033C16.9583 9.16699 16.5 9.62533 15.5833 9.62533H13.75C12.8333 9.62533 12.375 9.16699 12.375 8.25033V6.41699C12.375 5.50033 12.8333 5.04199 13.75 5.04199H15.5833C16.5 5.04199 16.9583 5.50033 16.9583 6.41699Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62508 13.75V15.5833C9.62508 16.5 9.16675 16.9583 8.25008 16.9583H6.41675C5.50008 16.9583 5.04175 16.5 5.04175 15.5833V13.75C5.04175 12.8333 5.50008 12.375 6.41675 12.375H8.25008C9.16675 12.375 9.62508 12.8333 9.62508 13.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 13.75V15.5833C16.9583 16.5 16.5 16.9583 15.5833 16.9583H13.75C12.8333 16.9583 12.375 16.5 12.375 15.5833V13.75C12.375 12.8333 12.8333 12.375 13.75 12.375H15.5833C16.5 12.375 16.9583 12.8333 16.9583 13.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBarcode);
export default __webpack_public_path__ + "static/media/scan-barcode.6b56ed6ebfc206ebf1cad4e4d1962264.svg";
export { ForwardRef as ReactComponent };